import { createServerStateStore } from "./serverState";

export interface BankTransferRecord {
  id: string;
  yuklemeNo?: number;
  tarih: string;
  fisNo: string;
  aciklama: string;
  tutar: number;
  automaticFilled: boolean;
  manualFilled: boolean;
  manualNote?: string;
  createdAt: string;
  updatedAt: string;
}

function normalizeTransfer(value: unknown, fallbackNo?: number): BankTransferRecord {
  const item = (value ?? {}) as Partial<BankTransferRecord>;
  const now = new Date().toISOString();
  return {
    id: String(item.id || crypto.randomUUID()),
    yuklemeNo: Number(item.yuklemeNo || fallbackNo || 0) || undefined,
    tarih: String(item.tarih || now.slice(0, 10)),
    fisNo: String(item.fisNo || "").trim(),
    aciklama: String(item.aciklama || "").trim(),
    tutar: Number(item.tutar || 0),
    automaticFilled: Boolean(item.automaticFilled),
    manualFilled: Boolean(item.manualFilled),
    manualNote: String(item.manualNote || "").trim(),
    createdAt: String(item.createdAt || now),
    updatedAt: String(item.updatedAt || now),
  };
}

function normalizeTransfers(value: unknown): BankTransferRecord[] {
  if (!Array.isArray(value)) return [];
  return value.map((item, index) => normalizeTransfer(item, index + 1)).filter((item) => item.fisNo);
}

const store = createServerStateStore<BankTransferRecord[]>(
  "bank_transfers",
  [],
  normalizeTransfers,
  { pollIntervalMs: 7000 }
);

export function getBankTransfers() {
  return store.getState();
}

export async function rehydrateBankTransfers() {
  return store.rehydrate();
}

export async function setAllBankTransfers(
  updater:
    | BankTransferRecord[]
    | ((prev: BankTransferRecord[]) => BankTransferRecord[])
) {
  return store.setState(updater);
}

export function subscribeBankTransfers(listener: () => void) {
  return store.subscribe(listener);
}

export function isBankTransferActive(item: BankTransferRecord) {
  return !item.automaticFilled && !item.manualFilled;
}

export function normalizeReceiptNo(value: string) {
  return String(value ?? "").trim().toLocaleLowerCase("tr-TR");
}
